"use client";
import { jsx } from "react/jsx-runtime";
import { Row } from "../../utilities/layout/Row.js";
import { tokens } from "@gnist/themes/tokens.css.js";
import reactContentLoader from "react-content-loader";
import { useId } from "react";
const ContentLoader = reactContentLoader;
const TextSkeleton = ({ className, height = "1em", width = "100%" }) => {
  const uniqueKey = useId();
  return jsx(Row, { className, style: {
    height: `calc(1em * ${tokens.typeface["line-height"]})`,
    width
  }, verticalAlign: "center", horizontalAlign: "end", children: jsx(ContentLoader, { uniqueKey, height, width, title: "", backgroundColor: tokens.color.loader, foregroundColor: tokens.color["on-loader"], children: jsx("rect", { x: "0", y: "0", rx: "4", ry: "6.7", height, width }) }) });
};
export {
  TextSkeleton
};
